type ProjectBudgetSynthesis = {
  plannedValueOfMaterialResourcesOfProject: string;
  plannedValueOfInternalResourcesOfProject: string;
  plannedValueOfExternalResourcesOfProject: string;
  percentOfPlannedValueOfExternalResourcesOfProject: number;
  percentOfPlannedValueOfMaterialResourcesOfProject: number;
  percentOfPlannedValueOfInternalResourcesOfProject: number;
  totalSumOfTimeAllocatedOnTheProject: string;
  finalPlannedValueOfProject: string;
  percentOfBudgetConsumption: string;
  percentOfAcquiredValue: string;
  totalOfRemainingTimeInProject: string;
  totalOfTimesSpentInProject: string;
  finalBalance: string;
  allocatedBudget: number;
  allocatedResourcesBudget: string;
  allocatedExpensesBudget: string;
  plannedValueAtDate: number;
  plannedValueAtDateOfResources: number;
  plannedValueAtDateOfExpenses: number;
  acquiredValueAtDate: number;
  acquiredValueAtDateOfResources: number;
  acquiredValueAtDateOfExpenses: number;
  realCostAtDate: number;
  realCostAtDateOfResources: number;
  realCostAtDateOfExpenses: number;
  plannedValue: number;
  plannedValueOfResources: number;
  plannedValueOfExpenses: number;
  realCost: number;
  realCostOfResources: number;
  realCostOfExpenses: number;
  acquiredValue: number;
  acquiredValueOfResources: number;
  acquiredValueOfExpenses: number;
};

const projectBudgetSynthesis: ProjectBudgetSynthesis = {
  plannedValueOfMaterialResourcesOfProject: "",
  plannedValueOfInternalResourcesOfProject: "",
  plannedValueOfExternalResourcesOfProject: "",
  percentOfPlannedValueOfExternalResourcesOfProject: 0,
  percentOfPlannedValueOfMaterialResourcesOfProject: 0,
  percentOfPlannedValueOfInternalResourcesOfProject: 0,
  totalSumOfTimeAllocatedOnTheProject: "",
  finalPlannedValueOfProject: "",
  percentOfBudgetConsumption: "0",
  percentOfAcquiredValue: "0",
  totalOfRemainingTimeInProject: "",
  totalOfTimesSpentInProject: "",
  finalBalance: "",
  allocatedBudget: 0,
  allocatedResourcesBudget: "",
  allocatedExpensesBudget: "",
  plannedValueAtDate: 0,
  plannedValueAtDateOfResources: 0,
  plannedValueAtDateOfExpenses: 0,
  acquiredValueAtDate: 0,
  acquiredValueAtDateOfResources: 0,
  acquiredValueAtDateOfExpenses: 0,
  realCostAtDate: 0,
  realCostAtDateOfResources: 0,
  realCostAtDateOfExpenses: 0,
  plannedValue: 0,
  plannedValueOfResources: 0,
  plannedValueOfExpenses: 0,
  realCost: 0,
  realCostOfResources: 0,
  realCostOfExpenses: 0,
  acquiredValue: 0,
  acquiredValueOfResources: 0,
  acquiredValueOfExpenses: 0,
};

export type { ProjectBudgetSynthesis };

export { projectBudgetSynthesis };
